import ActionButton from "../../../../components/Buttons/Action/ActionButton";
import Divider from "../../../../components/Decors/Divider/Divider";
import { QuestionTypes } from "../../constants/QuestionTypes";
import "../../GamePage.scss";

import { useGameStore } from "../../stores/gameStore";
import { Form } from "react-bootstrap";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { GameStates } from "../../constants/GameStates";

const Quiz = () => {
  const { t } = useTranslation();
  const { currentItem, playerAnswer } = useGameStore((state: any) => ({
    currentItem: state.currentItem,
    playerAnswer: state.playerAnswer,
  }));
  const { gameState, setGameState } = useGameStore((state: any) => ({
    gameState: state.gameState,
    setGameState: state.setGameState,
  }));

  const question = currentItem.question;
  const questionType = currentItem.type;
  let options: string[] =
    questionType === QuestionTypes.MULTIPLE_CHOICE ? currentItem.options : null;
  const [shortAnswer, setShortAnswer] = useState("");

  // To show cursor
  document.exitPointerLock();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    playerAnswer(shortAnswer);
  };

  return (
    <div className="quiz">
      <h1>{question}</h1>
      <Divider />
      {gameState === GameStates.SHOW_ANSWER && (
        <>
          <h3>{currentItem.solution}</h3>
          <div className="buttons-container">
            <ActionButton onClick={() => setGameState(GameStates.GAME)}>
              Next
            </ActionButton>
          </div>
        </>
      )}
      {(questionType === QuestionTypes.MULTIPLE_CHOICE &&
        gameState === GameStates.QUIZ) && (
          <div className="buttons-container">
            {options?.map((option, index) => (
              <ActionButton key={index} onClick={() => playerAnswer(option)}>
                {option}
              </ActionButton>
            ))}
          </div>
        )}
      {(questionType === QuestionTypes.SHORT_ANSWER &&
        gameState === GameStates.QUIZ) && (
          <Form
            onSubmit={handleSubmit}
            className="d-flex flex-column align-items-center gap-2"
          >
            <input
              type="text"
              value={shortAnswer}
              onChange={(e) => setShortAnswer(e.target.value)}
              placeholder={t("game.shortAnswerPlaceholder")}
              className={`short-answer-field ${shortAnswer ? "filled" : ""}`}
            />
            <ActionButton type="submit">{t("common.submit")}</ActionButton>
          </Form>
        )}
    </div>
  );
};

export default Quiz;
